import { render, staticRenderFns } from "./V2NavMenu.vue?vue&type=template&id=4b996eea&scoped=true&"
import script from "./V2NavMenu.vue?vue&type=script&lang=js&"
export * from "./V2NavMenu.vue?vue&type=script&lang=js&"
import style0 from "./V2NavMenu.vue?vue&type=style&index=0&id=4b996eea&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b996eea",
  null
  
)

export default component.exports